var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHat = function SvgHat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "27px",
    viewBox: "0 0 30 27",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "diffGroup 17")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LIbraway_loggato",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ricetta_new",
    transform: "translate(-1305.000000, -472.000000)",
    stroke: "#FFBF3F",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(1306.000000, 473.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3496822,5.13446247 C21.151283,5.13446247 20.9528837,5.14686705 20.7479049,5.17322678 C19.6010358,2.08707061 16.7576507,1.10134124e-13 13.5630179,1.10134124e-13 C10.3693974,1.10134124e-13 7.52651836,2.08707061 6.37914313,5.17322678 C6.17467043,5.14686705 5.97525895,5.13446247 5.7768597,5.13446247 C2.5913371,5.13446247 -4.47641924e-13,7.86863868 -4.47641924e-13,11.2287293 C-4.47641924e-13,14.2631997 2.11204096,16.7854644 4.86634887,17.2480518 L4.86634887,21.4971374 C4.86634887,23.1588343 6.14835217,24.5114504 7.72339925,24.5114504 L19.4026365,24.5114504 C20.9786959,24.5114504 22.260193,23.1588343 22.260193,21.4971374 L22.260193,20.1331504 L22.260193,17.2480518 C25.0150071,16.7854644 27.127048,14.2631997 27.127048,11.2287293 C27.127048,7.86863868 24.5357109,5.13446247 21.3496822,5.13446247 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    points: "4.86670315 19.5047551 10.3140784 19.5047551 22.2605473 19.5047551"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.9058557,
    y1: 12.2556218,
    x2: 10.3767361,
    y2: 19.5045483,
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.2209393,
    y1: 12.2556218,
    x2: 16.7500589,
    y2: 19.5045483,
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.5636758,
    y1: 11.0013637,
    x2: 13.5636758,
    y2: 19.5047034,
    id: "Stroke-9"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hat.6eebfcec.svg";
export { ForwardRef as ReactComponent };